import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'spa-icon',
  templateUrl: './spa-icon.component.html',
  styleUrls: ['./spa-icon.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpaIconComponent {
  fontSize = input<string>('24px');
  shape = input<'filled' | 'outlined' | 'round' | 'sharp'>('filled');
  tooltip = input<string>();

  iconClass = computed(() => {
    const shapeClass =
      this.shape() === 'filled' ? 'material-symbols-outlined filled' : `material-symbols-${this.shape()}`;
    const tooltipClass = this.tooltip() ? 'tooltip-container' : '';
    const iconClass = shapeClass + ' ' + tooltipClass;

    return iconClass;
  });
}
